import { PostloadedImage, Chevron } from '@utils/react';
import { portalCls, imgWrapperCls, imgCls, textWrapperCls, headingCls, gradeLevelCls, chevronCls } from './molecule.portal.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const FALLBACK_IMAGE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAABGCAMAAACwuZcuAAABSlBMVEUsKyktLCouLSwzMjAzMjE0MzE4NzU4NzY5ODY6OTc9PDo+PTtBQD5CQT9IR0ZLSkhLS0lNTEtUU1FVVFJYV1VZWFZbWllcW1peXVtfX11gX15hYF9oaGZqaWhraml5eHd8fHp9fHuBgX+CgYCEg4KFhIOFhYSHhoWIh4aJiIeKiYiOjYyOjo2Tk5KZmZiampmdnZyhoaCkpKOmpqWnp6apqaitrayvrq6wr66wsK+zs7K1tbS3t7a4uLe8vLu+vb3AwL/CwcHDwsLExMPFxcTGxsXIyMjJycjLy8rMy8vNzMzOzs3R0dHV1dTZ2dja2tnc3Nzd3d3f397g39/g4ODh4eHi4uLj4+Ll5OTl5eXm5ubp6ejr6+vs7Ozu7u3v7+/w8PDx8fHz8/L09PT29vb4+Pj5+fn6+vr7+/v8/Pz9/fz9/f3+/v7///8/6wnGAAACD0lEQVR4Ae2WyVMTQRhHP1lACUNkXwYhLBoB2QMjoAlhICiLGgRlRyAEksn7/6/WtGWB6QzGLo/zLr9D6lWlu79lJOQ/EhLS0Dc11dfwT4oVT12guEjFrSolO+3xAC9tVyFFXRSFHdgpoHCjf7NG8pDbhINWG+zWA9jMQX7kUalmEUqJzjzHlviaWMfkOxMlWKx5xErCSY+s4XXJL026PNak5wSSwZ4DuxHphnn5rck8dEtkF5zAc0G2USRJLnKvRXIkRRqzEHC+6C3gDlhFFuRekwWK1oAL3Fa+Txd88Rr6H2r9cO1L4FZ8ZUg0z17hc761POOAM7O8dY7P1WxzAmzRSZNrEqkdLKJRHKwVacqR1i3LY87PdpgYTWT2LgEu9zKJ0Qlo93+Zw9PrMw5tfsagRR6eTVog5mcbxDUtxaHKaW7kT01umFZ5SErTTnFUrpAt17KsqHQ41boSxsVng0y5lmFD5TiU920HTNo++2zbijEYsxXb7KuchI4ybZiqGDbXzP+k+ZWYP4DxcxsUl1bKQwNv3q5/PoOzT+vOxIshvZS1xnnSW0Cj0CtBjaPatO71Pj6low/vVmH1/ccjFF/jdQFtKi6lK6AIsfr7s9XHwAN+lHArj6A74MvLqD6Cnr/KAnfRwIH37WnlgffsOwQO9KXHxuuS+TA3Xx3mi8p8LZouYYOVb/6BERISYsBPpc4iilm07QkAAAAASUVORK5CYII=";
const Portal = ({
  portal
}) => {
  return /*#__PURE__*/jsx("li", {
    children: /*#__PURE__*/jsxs("a", {
      className: portalCls,
      href: portal.url,
      target: "_blank",
      rel: "noreferrer",
      children: [/*#__PURE__*/jsx("div", {
        className: imgWrapperCls,
        children: /*#__PURE__*/jsx(PostloadedImage, {
          className: imgCls,
          src: portal.thumbnail ?? FALLBACK_IMAGE,
          sizes: "71px",
          alt: ""
        })
      }), /*#__PURE__*/jsxs("div", {
        className: textWrapperCls,
        children: [/*#__PURE__*/jsx("h6", {
          className: headingCls,
          children: portal.title
        }), /*#__PURE__*/jsx("span", {
          className: gradeLevelCls,
          children: portal.formattedGradeLevel
        })]
      }), /*#__PURE__*/jsx(Chevron, {
        size: 9,
        lineWidth: 1.5,
        className: chevronCls
      })]
    })
  });
};

export { Portal };
//# sourceMappingURL=molecule.portal.js.map
